import DateHandler from '@/shared/utils/date-format';

export default function (value: string) {
  if (value) {
    const formatCompetence = () => DateHandler.fullMonthAndYear(value)
    return formatCompetence();
  }
  return value;
}
